import React from 'react';
import { Provider } from 'react-redux';
import 'react-phone-number-input/style.css';
import { Root, createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ClayIconSpriteContext } from '@clayui/icon';
import './index.css';
import './variable.css';
import App from './App';
import 'react-phone-number-input/style.css';
import store from './redux/store';

class WebComponent extends HTMLElement {
    private root: Root | undefined;

    connectedCallback() {
        if (!this.root) {
            this.root = createRoot(this);
            const queryClient = new QueryClient();
            this.root.render(
                <Provider store={store}>
                    <ClayIconSpriteContext.Provider
                        value={(window as any)?.Liferay?.Icons?.spritemap}
                    >
                        <QueryClientProvider client={queryClient}>
                            <App route={this.getAttribute('route')} />
                        </QueryClientProvider>
                    </ClayIconSpriteContext.Provider>
                </Provider>
            );
        }
    }
}

const ELEMENT_ID = 'customer-custom-element';

if (!customElements.get(ELEMENT_ID)) {
    customElements.define(ELEMENT_ID, WebComponent);
}
// For development mode - render to root div if it exists
if (process.env.NODE_ENV === 'development') {
    const rootElement = document.getElementById('root');
    if (rootElement) {
        const root = createRoot(rootElement);
        root.render(<App route={null} />);
    }
}